import { PostAdjusterOtherDamagedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAdjusterOtherDamagedImages/postAdjusterOtherDamagedImagesQuery.type';
import { postAdjusterOtherDamagedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAdjusterOtherDamagedImages/postAdjusterOtherDamagedImagesQueryFunction';

export const postAdjusterOtherDamagedImagesQueryOptions = () => {
  return {
    mutationKey: ['postAdjusterOtherDamagedImages'],
    mutationFn: (params: PostAdjusterOtherDamagedImagesQueryParamsType) =>
      postAdjusterOtherDamagedImagesFunction(params),
  };
};
